
// LAYOUTS
import DashboardLayout from '../layout/DashboardLayout';
import SaleLayout from '../layout/SaleLayout';

// Single Pages
import Login from '../views/Login';
import Locked from '../views/Locked';

// Home
import Sale from '../views/home/sale';
import Safe from '../views/home/safe';
import Reports from '../views/home/reports';

// Admin
import AllServices from '../views/admin/allServices';
import Dashboard from '../views/admin/dashboard';
import AdminSafe from '../views/admin/safe';
import Settings from '../views/admin/settings/index';
import AdminReports from '../views/admin/reports';
import AdminSalesReports from '../views/admin/serviceReports';

import GeneralExpenses from '../views/reports/GeneralExpenses';
import PastSafe from '../views/reports/PastSafe';
import IncomeExpensesReport from '../views/reports/IncomeExpensesReport';
import EmployeeReports from '../views/reports/EmployeeReports';
import Debt from '../views/accountings/Debt';
import Credit from '../views/accountings/Credit';
import AdminStorage from '../views/admin/storage';

const routes = [
  {
    path: '/giris-yap',
    name: 'login',
    component: Login,
  },
  {
    path: '/kilit',
    name: 'kilit',
    component: Locked,
  },

  {
    path: '/',
    name: 'home',
    component: SaleLayout,
    redirect: '/satis',
    children: [
      {
        path: '/satis',
        name: 'sale',
        component: Sale,
        meta: { title: 'Satış' },
      },
      {
        path: '/kasa',
        name: 'safe',
        component: Safe,
        meta: { title: 'Kasa' },
      },
      {
        path: '/gelir-gider',
        name: 'reports',
        component: Reports,
        meta: 'Gelir Gider',
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: '/yonetim',
    name: 'dashboard',
    component: DashboardLayout,
    redirect: '/satis',
    children: [
      {
        path: 'kasa',
        name: 'adminSafe',
        component: AdminSafe,
        meta: { title: 'Kasa' },
      },
      {
        path: 'gecmis-kasa/:type?',
        name: 'gecmis-kasa',
        component: PastSafe,
        meta: { title: 'Geçmiş Gün Sonları' },
      },
      {
        path: 'genel-giderler',
        name: 'generalExpenses',
        component: GeneralExpenses,
        meta: { title: 'Genel Giderler' },
      },
      {
        path: 'odeme-al',
        name: 'get-payment',
        component: Dashboard,
        meta: { title: 'Ödeme Al' },
      },
      {
        path: 'satis-raporlari/:type?',
        name: 'satis-raporlari',
        component: AdminSalesReports,
        meta: { title: 'Satış Raporları' },
      },
      {
        path: 'employee-reports/:type?',
        name: 'employee-reports',
        component: EmployeeReports,
        meta: { title: 'Personel Raporları' },
      },
      {
        path: 'urun-yonetimi/:type?',
        name: 'adminServices',
        component: AllServices,
        meta: { title: 'Ürün Yönetimi' },
      },
      {
        path: 'gelir-gider',
        name: 'adminReports',
        component: AdminReports,
        meta: { title: 'Gelir Gider' },
      },
      {
        path: 'gelir-gider-raporlari/:type?',
        name: 'incomeexpenses-reports',
        component: IncomeExpensesReport,
        meta: { title: 'Gelir Gider Raporları' },
      },
      {
        path: 'accountings/:id',
        name: 'accountings-credit',
        component: Credit,
        meta: { title: 'Ödemeler' },
      },
      {
        path: 'accountings/debts',
        name: 'accountings-debt',
        component: Debt,
        meta: { title: 'Ödemeler' },
      },
      {
        path: 'depo-islemleri',
        name: 'adminStorage',
        component: AdminStorage,
        meta: { title: 'Depo İşlemleri' },
      },
    ],
    meta: { requiresAuthAdmin: true },
  },
  {
    path: '/yonetim',
    name: 'dashboard',
    component: DashboardLayout,
    redirect: '/satis',
    children: [
      {
        path: 'ayarlar',
        name: 'settings',
        component: Settings,
        meta: { title: 'Ayarlar' },
      },
    ],
    meta: { requiresAuth: true },
  },
];

export default routes;
